import Grid from "@mui/material/Grid";
import { RateAdequacyTable } from "components/pricing/rateAdequacy/RateAdequacy";
import * as labels from "config.labels";
import { useSelector } from "react-redux";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import { selectRateAdequacyComparison } from "store/selectors/pricing/rateAdequacySelectors";

/*
 * The Rate Adequacy table (Analysis > Rate Adequacy) laid out for the Summary
 * printout: a print-label title over the Current Year | Previous Year table.
 * Visibility is gated by the caller.
 */
const PrintRateAdequacy = () => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const comparison = useSelector(selectRateAdequacyComparison);

  return (
    <Grid item xs={12} data-testid={"print-rate-adequacy"}>
      <span className={"print-label"}>
        {translateLabel(labels.RATE_ADEQUACY_TITLE, {
          default: "Rate Adequacy",
        })}
      </span>
      <RateAdequacyTable comparison={comparison} />
    </Grid>
  );
};

export default PrintRateAdequacy;
